import about from './src/about.vue'

let views = {
    about,
};

export default views;